<template>
  <div class="mt-2">
    <div class="col-12">

      <table class="table table-striped projects">
        <thead>
          <tr>
            <th>Müşteri Kodu</th>
            <th>Durum</th>
            <th>İstek / Sonuç Zamanı</th>
            <th>Bonusu</th>
            <th>Sonuc</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in data" :key="index">
            <td>{{ data.customerCode }}</td>
            <td>
              <badge :type="data.status ? 'success' : 'danger'"
                :label="data.status ? 'Bonus Verildi' : 'Bonus Verilmedi'" />
            </td>
            <td>
              {{ data.date | DateFormat }}
            </td>
            <td>{{ data.bonusName }}</td>
            <td>
              <span>
                <span v-if="data.status">
                  Bonus: {{ data.amount || 0 }} TL
                </span>
                <span v-else>
                  {{ data.islemLog }}
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import Badge from '../Common/Badge'

export default {
  name: 'UserBonuses',
  components: {
    'badge': Badge,
  },
  props: {
    data: Array
  },
  computed: {
    console: () => console,
    window: () => window,

  }, filters: {
    DateFormat(value) {
      if (!value) return "Giriş Yapılmamış";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  methods: {
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/UserProfile/UserBonuses.vue